export var HORIZONTAL_MENU_MARGINS = 43;